import { Route, Routes } from "react-router-dom";
import Report from "./report";

export default function ReportRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Report />} />
    </Routes>
  );
}
